import { NgModule } from "@angular/core";
import { LazyTooltipDirective } from "./lazy-tooltip.directive";

@NgModule({
  declarations: [
    LazyTooltipDirective,
  ],
  exports: [
    LazyTooltipDirective,
  ],
})
export class LazyTooltipModule { }
